import React from "react";
import { X } from "lucide-react";

interface StartNewRequestModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const StartNewRequestModal: React.FC<StartNewRequestModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-md w-full p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <X size={24} />
        </button>

        <h2 className="text-2xl font-heading font-bold text-gray-900 mb-4">
          Submit a new quote for analysis?
        </h2>

        <p className="text-gray-600 mb-6">
          This will erase your current analysis. You’ll lose access to this
          quote and its results.
        </p>

        <div className="flex justify-end space-x-4">
          <button onClick={onClose} className="btn-secondary">
            Cancel
          </button>
          <button onClick={onConfirm} className="btn-primary">
            Start New Analysis
          </button>
        </div>
      </div>
    </div>
  );
};

export default StartNewRequestModal;
